import { useGetFaultDetailsQuery } from "../../api/faultsApi.js";
import { TechnicianLogDetails } from "./TechnicianLogDetails.tsx";

export const FaultDetails = ({ faultId, onOpenFilesDialog }) => {
  const { data: fault, isLoading } = useGetFaultDetailsQuery(
    { faultId },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return fault.logs.map((log) => (
    <TechnicianLogDetails
      key={log.id}
      technicianLogId={log.id}
      onOpenFilesDialog={onOpenFilesDialog}
    />
  ));
};
